var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgNotificationUnselected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10 1v1.9l.8.1c2.5.5 4.2 2.5 4.2 5v7.4l.6.2.2.1H4.2l.2-.1.6-.3V8c0-2.4 1.7-4.5 4.1-4.9l.9-.2V1m0-1c-.6 0-1 .5-1 1v1c-2.9.6-5 3-5 6v6.7l-2.1.8v1.2H18v-1.2l-2-.9V8c0-3-2.2-5.4-5-5.9V1c0-.5-.4-1-1-1zm2.2 17.6H7.8v.2c0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2v-.2z",
    fill: "#e1087e"
  })));
}
export default SvgNotificationUnselected;